"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.weak-map.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

require("core-js/modules/es6.object.get-own-property-descriptor.js");

require("core-js/modules/es6.symbol.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.replace.js");

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var querystring = _interopRequireWildcard(require("querystring"));

var _constants = require("@evdy/web-redux/dist/constants");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Map = /*#__PURE__*/function (_React$Component) {
  _inherits(Map, _React$Component);

  var _super = _createSuper(Map);

  function Map(props) {
    var _this;

    _classCallCheck(this, Map);

    _this = _super.call(this, props);
    _this.makeMapImage = _this.makeMapImage.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Map, [{
    key: "makeMapImage",
    value: function makeMapImage() {
      var _this$props = this.props,
          zoom = _this$props.zoom,
          size = _this$props.size,
          mapClass = _this$props.mapClass,
          isBackground = _this$props.isBackground,
          gaLabel = _this$props.gaLabel,
          noMarkers = _this$props.noMarkers,
          data = _this$props.data,
          customSize = _this$props.customSize;
      var street = data.street,
          city = data.city,
          state = data.state,
          coords = data.coords;
      var coordString = "".concat(coords[0], ",").concat(coords[1]);
      var spaceRegex = / /g;
      var locationString = "".concat(street, "+").concat(city, "+").concat(state).replace(spaceRegex, '+');
      var center = coords[0] && coords[1] ? coordString : locationString;
      var markers = center;
      var minScreenDimension;

      if (typeof window !== 'undefined') {
        // matching map width to the width of the screen
        var doc = document.documentElement;
        minScreenDimension = Math.min(doc.clientWidth, doc.clientHeight) || 640;
      } else {
        minScreenDimension = 640;
      }

      var query = querystring.stringify({
        zoom: zoom,
        key: _constants.GMAPS_API_KEY,
        center: center,
        markers: noMarkers ? null : markers,
        size: customSize ? "".concat(customSize) : "".concat(minScreenDimension, "x").concat(size)
      });

      if (isBackground) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "event-map-image ".concat(mapClass),
          style: {
            backgroundImage: "url(".concat(_constants.GMAPS_URL, "?").concat(query, ")")
          }
        });
      } else {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "event-map ".concat(mapClass)
        }, /*#__PURE__*/_react.default.createElement("img", {
          className: "event-map-image",
          src: "".concat(_constants.GMAPS_URL, "?").concat(query)
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$data = this.props.data,
          street = _this$props$data.street,
          city = _this$props$data.city,
          state = _this$props$data.state,
          coords = _this$props$data.coords;
      var shouldRender = coords && coords.length === 2 || street && state && city;
      return shouldRender ? this.makeMapImage() : null;
    }
  }]);

  return Map;
}(_react.default.Component);

exports.default = Map;
Map.propTypes = {
  data: _propTypes.default.object.isRequired,
  zoom: _propTypes.default.number,
  size: _propTypes.default.string,
  mapClass: _propTypes.default.string,
  isBackground: _propTypes.default.bool,
  gaLabel: _propTypes.default.string
};
Map.defaultProps = {
  zoom: 16,
  size: '200',
  mapClass: 'announcement-builder-services-map',
  gaLabel: 'map'
};